import { isFeedBlock } from "../../guards";
import { TagContext, Tagger } from "@ihr-radioedit/inferno-core";
import { Tags } from "@ihr-radioedit/inferno-core";
import { generateMetaTag } from "../util";

export const micrositeFeedTags: Tagger = (state: Tags, context: TagContext) => {
    const { block, microsite } = context;

    if (block && isFeedBlock(block) && microsite && microsite.config) {
        const { metadata } = state;
        const { sections } = microsite;

        if (metadata && sections.general?.name) {
            metadata.set(...generateMetaTag("name", "parsely-section", sections.general.name));

            return {
                ...state,
                metadata,
            };
        }
    }
    return state;
};
